module.exports = __webpack_public_path__ + "img/75676.f4baa77f.svg";